import SnagsDashboard from "../../../components/snags/SnagsDashboard";

export default function SnagsManagement({ organizationId, currentMember }) {
  const token = localStorage.getItem("access");
  const siteId = currentMember?.site?.id || currentMember?.site_id || 1;
  const isAdmin = currentMember?.is_admin || currentMember?.joined_as === "owner" || currentMember?.snag_admin === true;
  return (
    <div className="flex-1 max-w-none px-10 pt-8 pb-0">
      <SnagsDashboard
        organizationId={organizationId}
        currentMember={currentMember}
        siteId={siteId}
        token={token}
        isAdmin={isAdmin}
      />
    </div>
  );
}
